import React from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "./ui/sheet";
import { useCart } from "../contexts/CartContext";
import { useApp } from "../contexts/AppContext";
import { Minus, Plus, X, Gift } from "lucide-react";
import { Link } from "react-router-dom";

export default function CartDrawer() {
  const { items, open, setOpen, setQty, remove, subtotalAzn } = useCart();
  const { t, formatPrice } = useApp();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="bg-[var(--bg)] border-[var(--border)] text-[var(--text)] w-full sm:max-w-md p-0 rounded-none">
        <SheetHeader className="p-6 border-b border-[var(--border)]">
          <SheetTitle className="font-display text-3xl">{t.common.cart}</SheetTitle>
          <div className="metadata">{items.length} {items.length === 1 ? t.common.item : t.common.items}</div>
        </SheetHeader>

        <div className="flex flex-col h-[calc(100vh-180px)]">
          <div className="flex-1 overflow-y-auto p-6 space-y-5" data-testid="cart-items">
            {items.length === 0 && (
              <div className="text-[var(--text-2)] text-sm">{t.common.empty}</div>
            )}
            {items.map((it) => (
              <div key={it.product_id} className="flex gap-4 pb-5 border-b border-[var(--border-soft)]" data-testid={`cart-item-${it.product_id}`}>
                {it.is_gift_card && !it.cover_url ? (
                  <div className="w-20 h-20 border border-[var(--border-soft)] bg-[var(--surface)] flex items-center justify-center text-[var(--primary)]">
                    <Gift size={24} />
                  </div>
                ) : (
                  <img src={it.cover_url} alt={it.title} className="w-20 h-20 object-cover" />
                )}
                <div className="flex-1 min-w-0">
                  {it.is_gift_card ? (
                    <div className="metadata text-[var(--primary)] flex items-center gap-1"><Gift size={10} /> HƏDİYYƏ KARTI</div>
                  ) : (
                    <div className="metadata text-[var(--text-muted)]">{it.artist_name}</div>
                  )}
                  <div className="font-display text-lg mt-1 truncate">{it.title}</div>
                  {it.is_gift_card && (it.recipient_name || it.recipient_email) && (
                    <div className="metadata text-[var(--text-muted)] mt-1 normal-case tracking-normal text-xs truncate">
                      → {it.recipient_name || it.recipient_email}
                    </div>
                  )}
                  <div className="flex items-center gap-3 mt-2">
                    {it.is_gift_card ? (
                      <span className="metadata text-[var(--text-muted)]">×1</span>
                    ) : (
                      <>
                        <button className="w-7 h-7 border border-[var(--border)] flex items-center justify-center" onClick={() => setQty(it.product_id, it.qty - 1)}><Minus size={12} /></button>
                        <span className="font-mono text-sm">{it.qty}</span>
                        <button className="w-7 h-7 border border-[var(--border)] flex items-center justify-center" onClick={() => setQty(it.product_id, it.qty + 1)}><Plus size={12} /></button>
                      </>
                    )}
                    <button className="ml-auto text-[var(--text-muted)] hover:text-[var(--accent)]" onClick={() => remove(it.product_id)}><X size={14} /></button>
                  </div>
                </div>
                <div className="font-mono text-sm">{formatPrice(it.price_azn * it.qty)}</div>
              </div>
            ))}
          </div>

          <div className="p-6 border-t border-[var(--border)] bg-[var(--surface)]">
            <div className="flex justify-between mb-4">
              <span className="metadata">{t.common.subtotal}</span>
              <span className="font-display text-2xl" data-testid="cart-subtotal">{formatPrice(subtotalAzn)}</span>
            </div>
            <Link to="/checkout" onClick={() => setOpen(false)} className="btn-primary w-full justify-center" data-testid="checkout-link">
              {t.common.checkout}
            </Link>
          </div>
        </div>
      </SheetContent>
    </Sheet>
  );
}
